export const REFUND_25 = { value: 25, label: '25% - 60 - 119' };
export const REFUND_30 = { value: 30, label: '30% - 60 - 119' };
export const REFUND_50 = { value: 50, label: '50% - 120 - 179' };
export const REFUND_60 = { value: 60, label: '60% - 120 - 179' };
export const REFUND_75 = { value: 75, label: '75% - 180+' };
export const REFUND_100 = { value: 100, label: '100%', isExecutiveDecision: true };

export const ERROR_MODAL_TYPE = {
  CARD: 'CARD',
  VOUCHER: 'VOUCHER',
  BUSINESS_ACCOUNT: 'BUSINESS_ACCOUNT',
  LOYALTY: 'LOYALTY',
  NONE: 'NONE'
};
